import React from "react";
import { Link } from "react-router-dom";
import { ProductCard } from "../ProductCard";

export const FeaturedEdit = ({ products }) => (
  <section className="bg-[#efe6db]" data-testid="featured-section">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-6 lg:px-12 py-16 sm:py-24">
      <div className="flex items-end justify-between mb-10 sm:mb-14">
        <div>
          <div className="micro-label text-[#1a1814]/60 mb-3 sm:mb-4">The Edit</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#1a1814] max-w-xl leading-tight">
            Seven pieces, drafted twice — once for cut, once for length.
          </h2>
        </div>
        <Link to="/shop" className="micro-label hover:opacity-60 hidden sm:inline whitespace-nowrap" data-testid="featured-view-all">
          View all →
        </Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-10">
        {products.map((p, i) => (
          <ProductCard key={p.id} product={p} index={i} />
        ))}
      </div>
      <div className="mt-10 sm:hidden text-center">
        <Link to="/shop" className="micro-label border border-[#1a1814] px-8 py-3 inline-block hover:bg-[#1a1814] hover:text-[#f0e9e1]" data-testid="featured-view-all-mobile">
          View all →
        </Link>
      </div>
    </div>
  </section>
);
